// GA4 + Microsoft Clarity SPA計測 ヘルパー
//
// GA4の自動 send_page_view は index.html 側で send_page_view: false にしてあるので、
// React Router の遷移ごとに手動で gtag('event','page_view',...) を発火する必要がある。

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
    clarity?: (...args: unknown[]) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-4MVT41MJW6';

/**
 * SPA ページビューを GA4 へ送信
 * React Router の遷移後に呼び出す
 */
export function trackPageView(path: string, title?: string): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title ?? document.title,
    page_location: window.location.href,
    send_to: GA_MEASUREMENT_ID,
  });
}

/**
 * カスタムイベント送信 (例: カート追加、購入クリック等)
 */
export function trackEvent(
  eventName: string,
  params: Record<string, unknown> = {},
): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', eventName, params);
}

/**
 * 商品閲覧の eCommerce イベント
 */
export function trackViewItem(item: {
  id: string;
  name: string;
  price?: number;
  category?: string;
  brand?: string;
}): void {
  trackEvent('view_item', {
    currency: 'JPY',
    value: item.price ?? 0,
    items: [
      {
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        item_brand: item.brand,
        price: item.price ?? 0,
        quantity: 1,
      },
    ],
  });
}

/**
 * カート追加イベント
 */
export function trackAddToCart(item: {
  id: string;
  name: string;
  price?: number;
  quantity?: number;
}): void {
  trackEvent('add_to_cart', {
    currency: 'JPY',
    value: (item.price ?? 0) * (item.quantity ?? 1),
    items: [
      {
        item_id: item.id,
        item_name: item.name,
        price: item.price ?? 0,
        quantity: item.quantity ?? 1,
      },
    ],
  });
}

/**
 * Clarityにカスタムタグを送信 (任意)
 * 例: trackClarityTag('user_type', 'admin')
 */
export function trackClarityTag(key: string, value: string): void {
  if (typeof window === 'undefined' || !window.clarity) return;
  window.clarity('set', key, value);
}
